import { Model } from "@vuex-orm/core";
import { BatchTicket, RawTicket } from "./Ticket";
import Batch from "./Batch";
import WorkOrder from "./WorkOrder";
import Project from "./Project";
import Material from "./Material";

export class BatchTicketAttachment extends Model {
  static entity = "batchticketattachments";

  static $fetch() {
    return this.api().get('BatchTicketAttachments/')
  }
  static $get (id) {
    return this.api().get(`BatchTicketAttachments/${id}/`)
  }
  static $put (id, data) {
    return this.api().put(`BatchTicketAttachments/${id}/`, data)
  }
  static $patch (id, data) {
    return this.api().patch(`BatchTicketAttachments/${id}/`, data)
  }
  static $post (data) {
    return this.api().post(`BatchTicketAttachments/`, data)
  }
  static $delete (id) {
    return this.api().delete(`BatchTicketAttachments/${id}/`, { delete: id })
  }

  static fields() {
    return {
      id: this.attr(null),
      upload: this.string(""),
      name: this.string(""),
      uploaded_at: this.string(new Date(), value =>
        new Date(value).toLocaleString()
      ),
      batchticket: this.belongsTo(BatchTicket, "batchticket_id"),
      batchticket_id: this.attr(null)
    };
  }
}


export class RawTicketAttachment extends Model {
  static entity = 'rawticketattachments';

  static $fetch() {
    return this.api().get('RawTicketAttachments/')
  }
  static $get (id) {
    return this.api().get(`RawTicketAttachments/${id}/`)
  }
  static $put (id, data) {
    return this.api().put(`RawTicketAttachments/${id}/`, data)
  }
  static $patch (id, data) {
    return this.api().patch(`RawTicketAttachments/${id}/`, data)
  }
  static $post (data) {
    return this.api().post(`RawTicketAttachments/`, data)
  }
  static $delete (id) {
    return this.api().delete(`RawTicketAttachments/${id}/`, { delete: id })
  }

  static fields() {
    return {
      id: this.attr(null),
      upload: this.string(""),
      name: this.string(""),
      uploaded_at: this.string(new Date(), value =>
        new Date(value).toLocaleString()
      ),
      rawticket: this.belongsTo(RawTicket, "rawticket_id"),
      rawticket_id: this.attr(null)
    };
  }
}


export class BatchAttachment extends Model {
  static entity = 'batchattachments';

  static $fetch() {
    return this.api().get('BatchAttachments/')
  }
  static $get (id) {
    return this.api().get(`BatchAttachments/${id}/`)
  }
  static $put (id, data) {
    return this.api().put(`BatchAttachments/${id}/`, data)
  }
  static $patch (id, data) {
    return this.api().patch(`BatchAttachments/${id}/`, data)
  }
  static $post (data) {
    return this.api().post(`BatchAttachments/`, data)
  }
  static $delete (id) {
    return this.api().delete(`BatchAttachments/${id}/`, { delete: id })
  }

  static fields() {
    return {
      id: this.attr(null),
      upload: this.string(""),
      name: this.string(""),
      uploaded_at: this.string(new Date(), value =>
        new Date(value).toLocaleString()
      ),
      batch: this.belongsTo(Batch, "batch_id"),
      batch_id: this.attr(null)
    };
  }
}


export class ProjectAttachment extends Model {
  static entity = 'projectattachments';

  static $fetch() {
    return this.api().get('ProjectAttachments/')
  }
  static $get (id) {
    return this.api().get(`ProjectAttachments/${id}/`)
  }
  static $put (id, data) {
    return this.api().put(`ProjectAttachments/${id}/`, data)
  }
  static $patch (id, data) {
    return this.api().patch(`ProjectAttachments/${id}/`, data)
  }
  static $post (data) {
    return this.api().post(`ProjectAttachments/`, data)
  }
  static $delete (id) {
    return this.api().delete(`ProjectAttachments/${id}/`, { delete: id })
  }

  static fields() {
    return {
      id: this.attr(null),
      upload: this.string(""),
      name: this.string(""),
      uploaded_at: this.string(new Date(), value =>
        new Date(value).toLocaleString()
      ),
      project: this.belongsTo(Project, "project_id"),
      project_id: this.attr(null)
    };
  }
}


export class WorkOrderAttachment extends Model {
  static entity = 'workorderattachments';

  static $fetch() {
    return this.api().get('WorkOrderAttachments/')
  }
  static $get (id) {
    return this.api().get(`WorkOrderAttachments/${id}/`)
  }
  static $put (id, data) {
    return this.api().put(`WorkOrderAttachments/${id}/`, data)
  }
  static $patch (id, data) {
    return this.api().patch(`WorkOrderAttachments/${id}/`, data)
  }
  static $post (data) {
    return this.api().post(`WorkOrderAttachments/`, data)
  }
  static $delete (id) {
    return this.api().delete(`WorkOrderAttachments/${id}/`, { delete: id })
  }

  static fields() {
    return {
      id: this.attr(null),
      upload: this.string(""),
      name: this.string(""),
      uploaded_at: this.string(new Date(), value =>
        new Date(value).toLocaleString()
      ),
      workorder: this.belongsTo(WorkOrder, "workorder_id"),
      workorder_id: this.attr(null)
    };
  }
}


export class MaterialAttachment extends Model {
  static entity = 'materialattachments';

  static $fetch() {
    return this.api().get('MaterialAttachments/')
  }
  static $get (id) {
    return this.api().get(`MaterialAttachments/${id}/`)
  }
  static $put (id, data) {
    return this.api().put(`MaterialAttachments/${id}/`, data)
  }
  static $patch (id, data) {
    return this.api().patch(`MaterialAttachments/${id}/`, data)
  }
  static $post (data) {
    return this.api().post(`MaterialAttachments/`, data)
  }
  static $delete (id) {
    return this.api().delete(`MaterialAttachments/${id}/`, { delete: id })
  }

  static fields() {
    return {
      id: this.attr(null),
      upload: this.string(""),
      name: this.string(""),
      uploaded_at: this.string(new Date(), value =>
        new Date(value).toLocaleString()
      ),
      material: this.belongsTo(Material, "material_id"),
      material_id: this.attr(null)
    };
  }
}

